import { render } from "./SupervisorLearningManagementPage.vue?vue&type=template&id=5ab89a20&scoped=true"
import script from "./SupervisorLearningManagementPage.vue?vue&type=script&lang=js"
export * from "./SupervisorLearningManagementPage.vue?vue&type=script&lang=js"

import "./SupervisorLearningManagementPage.vue?vue&type=style&index=0&id=5ab89a20&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ab89a20"]])

export default __exports__